import ResourceService from "./resource.service";

class HajjGarageTransferService extends ResourceService {
  static get resource() {
    return "hajj-garage-transfer";
  }

  static getPrintPayload(tripId) {
    return this.get(`print-payload/${tripId}`);
  }
}

export default HajjGarageTransferService;

